import React from 'react';
import './placeholder-indicator.scss';

interface PlaceholderIndicatorProps {
  text: string;
}

const PlaceholderIndicator: React.FC<PlaceholderIndicatorProps> = ({
  text,
}) => {
  return (
    <div className="placeholder-indicator">
      <div className="placeholder-indicator__animation">
        {/* Spinning circle */}
        <svg
          className="placeholder-indicator__spinner"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="16"
            cy="16"
            r="14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeDasharray="20 70"
            strokeLinecap="round"
          />
        </svg>

        {/* Pulsing logo */}
        <div className="placeholder-indicator__logo">
          <img
            src="https://lib.socialchorus.com/novabot/indicator.png"
            alt=""
            width={20}
            height={20}
          />
        </div>
      </div>
      <span className="placeholder-indicator__text">{text}</span>
    </div>
  );
};

export default PlaceholderIndicator;
